const CropIcon = () => {
	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="0.5"
				y="0.5"
				width="13"
				height="13"
				rx="1.5"
				stroke="var(--secondary-color)"
				strokeOpacity="0.85"
			/>
			<circle cx="5" cy="5" r="1" fill="var(--secondary-color)" />
			<circle cx="9" cy="5" r="1" fill="var(--secondary-color)" />
			<circle cx="5" cy="9" r="1" fill="var(--secondary-color)" />
			<circle cx="9" cy="9" r="1" fill="var(--secondary-color)" />
		</svg>
	);
};

export default CropIcon;
